export default __webpack_public_path__ + "static/media/ViewButtonOff.84b89e8e.svg";